import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useRouteMatch } from "react-router-dom";

import { getCookie } from "../../../../utils/cookies";
import { ERROR_MESSAGE_UNEXPECTED_ERROR } from "../../../../utils/consts";
import {
  fetchBannerInfo,
  fetchLoyaltyProgramInfo,
} from "../../../../services/customerApp/customerDetails";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";
import Authorities from "../../../../auth/authorities";
import withAuthority from "../../../../components/Auth/withAuthority";
import BannerNode from "./BannerNode";
import { Box, Hidden } from "@material-ui/core";
import PageHeaderMobile from "../../../../components/common/PageHeader/PageHeaderMobile";
import AlertDialogDefault from "../../../../components/alerts/AlertDialogDefault";
import AvailabilitySelection from "../../../../components/time/AvailabilitySelection";

export interface CustomerNodeProps {
  originalNodeData: any;
  handleSubmitAvailability: any;
  setAvailabilityErrorMessage: any;
}

/**
 * BannerListPage Component
 *
 * This component is responsible for rendering a paginated list of customer data.
 * It fetches customer information from an API and allows users to navigate through pages and sort the data.
 */
const BannerListPage: React.FunctionComponent<CustomerNodeProps> = ({
  originalNodeData,
  handleSubmitAvailability,
  setAvailabilityErrorMessage,
}) => {
  return (
    <>
      <AvailabilitySelection
        nodeData={originalNodeData}
        disabled={false}
        handleSubmit={handleSubmitAvailability}
        setAvailabilityErrorMessage={setAvailabilityErrorMessage}
        backgroundColor="entity_background"
      />
    </>
  );
};

export default withAuthority(BannerListPage, Authorities.STOCK_CONFIGURATION_CREATE);
